// src/pages/CrearTecnico.js
import React, { useState } from 'react';
import { crearTecnico } from '../services/tecnicoService';

const CrearTecnico = ({ token }) => {
  const [form, setForm] = useState({
    nombre: '',
    rut: '',
    especialidad: '',
    zonas: '',
    servicios: '',
    tarifas: '',
    telefono: '',
  });
  const [mensaje, setMensaje] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resultado = await crearTecnico(form, token);
    setMensaje(resultado.mensaje || 'Técnico registrado correctamente');
    setForm({ nombre: '', rut: '', especialidad: '', zonas: '', servicios: '', tarifas: '', telefono: '' });
  };

  return (
    <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
      <h2 className="text-xl font-bold mb-4">Registrar Técnico</h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-3">
        <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Nombre" className="p-2 border" required />
        <input name="rut" value={form.rut} onChange={handleChange} placeholder="RUT" className="p-2 border" />
        <input name="especialidad" value={form.especialidad} onChange={handleChange} placeholder="Especialidad" className="p-2 border" />
        <input name="zonas" value={form.zonas} onChange={handleChange} placeholder="Zonas" className="p-2 border" />
        <input name="servicios" value={form.servicios} onChange={handleChange} placeholder="Servicios" className="p-2 border" />
        <input name="tarifas" value={form.tarifas} onChange={handleChange} placeholder="Tarifas" className="p-2 border" />
        <input name="telefono" value={form.telefono} onChange={handleChange} placeholder="Teléfono" className="p-2 border" />
        <button type="submit" className="bg-blue-600 text-white py-2 rounded">Guardar técnico</button>
      </form>
      {mensaje && <p className="mt-4 text-green-600 font-semibold">{mensaje}</p>}
    </div>
  );
};

export default CrearTecnico;
